import Header from "@bit/taillislabs.pega.header";
import { Table } from "antd";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import Pagination from "shared/components/Pagination";
import { NAME_SPACES } from "shared/locales/constants";
import { SCREENS } from "utils/constants";

function List({ data, count, setValues, skip }) {
  const navigate = useNavigate();
  const { t } = useTranslation(NAME_SPACES.PRIVATE.BROKER.ORGANIZATION);
  const LIST = t("LIST", { returnObjects: true });

  const columns = [
    {
      title: LIST.ID,
      dataIndex: "id",
      render: (item) => item || "-",
    },
    {
      title: LIST.NAME,
      dataIndex: "name",
      render: (item) => item || "-",
    },
  ];

  return (
    <>
      <Header
        key={"header"}
        title={LIST.HEADER.TITLE}
        okText={LIST.HEADER.SAVE}
        cancelText={LIST.HEADER.REFRESH}
        hideButtons={false}
        onOkClick={() =>
          navigate(SCREENS.PRIVATE.BROKER.ORGANIZATIONS.CREATE.path)
        }
        onCancelClick={() => {}}
      />
      <Table
        dataSource={data}
        columns={columns}
        rowKey={"id"}
        onRow={(record) => ({
          onClick: () =>
            navigate(
              `${SCREENS.PRIVATE.BROKER.ORGANIZATIONS.DETAIL.path}/${record.id}`
            ),
        })}
        pagination={false}
        scroll={{ x: true }}
      />
      <br />
      <Pagination count={count} setValues={setValues} skip={skip} />
    </>
  );
}

export default List;
